import Main from 'src/components/Main/Main';
import { connect } from 'react-redux';
import { FrameworkActionCreator, CustomerActionCreator, AppointmentActionCreator, VehiclesActionCreator, AdditionalServicesActionCreator, NewVehicleActionCreator, WebOpsActionCreator, SpecsActionCreator, RepairOrdersActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    rtsToken: state.Framework.rtsToken,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    viewMode: state.Framework.viewMode,
    specData: state.Specs.specs,
    selectedVehicle: state.Vehicles.selectedVehicle !== undefined ? state.Vehicles.selectedVehicle : '',
    vehicles: state.Vehicles.vehicles,
    newVehOptions: state.NewVehicle.NewVehicle,
    custVehicles: state.Customer.Customer?.vehicleList,
    custNameId: state.Customer.Customer?.nameId,
    theme: state.Framework.theme,
    apptVeh: state.Appointment.ApptVeh,
    serviceDocsSpecs: state.Specs.serviceDocsSpecs,
    profileNum: state.Framework.specProfile,
    serviceDocsFlag: state.Framework.serviceDocsFlag,
    viewServiceHistFlag: state.Framework.viewServiceHistFlag,
    multipleCustomers: (state.Customer.multipleCustomers && !state.Customer.Customer.login) ?? false,
    apptCust: state.Appointment.ApptCust,
    locale: state.Framework.locale,
    login: state.Customer.Customer.login,
    countryCode: state.Framework.dealerCountry,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    clearAdditionalServices: AdditionalServicesActionCreator.ClearAdditionalServices,
    clearMaintContractData: AdditionalServicesActionCreator.ClearMaintContractData,
    onUpdateApptVehicle: AppointmentActionCreator.UpdateApptVehicle,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    getVehicles: VehiclesActionCreator.GetVehicles,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    clearCheckedWebOps: WebOpsActionCreator.ClearCheckedWebOps,
    updateApptOps: AppointmentActionCreator.UpdateApptOps,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    updateApptCust: AppointmentActionCreator.UpdateApptCust,
    clearCheckedAdditionalServices: AdditionalServicesActionCreator.ClearCheckedAdditionalServices,
    clearApptCust: AppointmentActionCreator.ClearApptCust,
    setVerifyingIdentity: CustomerActionCreator.SetVerifyingIdentity,
    setSendSecurityCode: CustomerActionCreator.SetSendSecurityCode,
    waitForLogOff: CustomerActionCreator.WaitForLogOff,
    logCustOff: CustomerActionCreator.LogCustOff,
    clearAddVinError: VehiclesActionCreator.ClearAddVinError,
    clearGMInfo: CustomerActionCreator.ClearGMInfo,
    toggleLangLits: SpecsActionCreator.ToggleLangLits,
    toggleLocale: FrameworkActionCreator.setLocale,
    toggleOpsLangLits: WebOpsActionCreator.ToggleOpsLangLits,
    toggleROLangLits: RepairOrdersActionCreator.ToggleROLangLits,
    toggleApptLangLits: AppointmentActionCreator.ToggleApptLangLits,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Main);